var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9065 26.2847H4.1919C2.66422 26.2847 1.42578 27.5231 1.42578 29.0508V41.66C1.42578 43.1877 2.66422 44.4261 4.1919 44.4261H45.9065C47.4342 44.4261 48.6726 43.1877 48.6726 41.66V29.0508C48.6726 27.5231 47.4342 26.2847 45.9065 26.2847Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7978 26.2848H6.625V22.2793C6.625 21.6104 6.89071 20.969 7.36368 20.496C7.83664 20.023 8.47812 19.7573 9.147 19.7573H14.2758C14.9446 19.7573 15.5861 20.023 16.0591 20.496C16.532 20.969 16.7978 21.6104 16.7978 22.2793V26.2848Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7959 19.7575V2.20947",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6532 26.2848H32.4805V22.2793C32.4805 21.6104 32.7462 20.969 33.2191 20.496C33.6921 20.023 34.3336 19.7573 35.0025 19.7573H40.1312C40.4624 19.7573 40.7904 19.8226 41.0964 19.9493C41.4023 20.076 41.6804 20.2618 41.9146 20.496C42.1487 20.7302 42.3345 21.0082 42.4613 21.3142C42.588 21.6202 42.6532 21.9481 42.6532 22.2793L42.6532 26.2848Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6514 19.7575V2.20947",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88574 48.6929H41.5516",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88574 35.3555H16.7979",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9297 35.3555H35.1299",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6553 35.3555H41.8555",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.0488281 0.451172)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg16);
export default __webpack_public_path__ + "static/media/Website icons SVG-16.0864d54dfe03bd616aad67a5b137d1b2.svg";
export { ForwardRef as ReactComponent };